//data service
//service for accessing and sending data
import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "../BaseUrl";
import { SpeedSharp } from "@mui/icons-material";

const API_URL = BASE_URL;
const UNIDESK_URL = "https://mis.mescray001.com/Tracker/";
// const UNIDESK_URL = "http://uat.mescray001.com/";

export const headers = { headers: authHeader() };

//Third party api
const getBatchData = async (body) => {
  let requestOptions = {
    method: "POST",
    data: JSON.stringify({
      method_name: "get_all_batches_filter",
      ...body,
    }),
    url: UNIDESK_URL+"api/v1/index.php",
  };
  const response = await axios.request(requestOptions);
  return response.data;
};
const getDateList = async (date) => {
  let requestOptions = {
    method: "POST",
    data: {
      date:date,
    },
    url: UNIDESK_URL+"project/faculty_api/?/Motionapi/faculty_calendar",
  };
  const response = await axios.request(requestOptions);
  return response.data;
};
const getScheduleList = async (body) => {
  let requestOptions = {
    method: "POST",
    data:body,
    headers: { 
      'Content-Type': 'application/json'
    },
    url: UNIDESK_URL+"project/faculty_api/?/Motionapi/faculty_tt",
  };
  const response = await axios.request(requestOptions);
  return response.data;
};
const getReports = async (body) => {
  let requestOptions = {
    method: "POST",
    data:body,
    url: UNIDESK_URL+"project/faculty_api/?/Motionapi/view_faculty_course_reports",
  };
  const response = await axios.request(requestOptions);
  return response.data;
};
const addCourseReport = async (body) => {
  let requestOptions = {
    method: "POST",
    data:body,
    url: UNIDESK_URL+"project/faculty_api/?/Motionapi/add_faculty_course_reports",
  };
  const response = await axios.request(requestOptions);
  return response.data;
};
const getAttendanceData = async (body) => {
  let requestOptions = {
    method: "POST",
    data:body,
    url: UNIDESK_URL+"project/faculty_api/?/Motionapi/view_student_attendance_count",
  };
  const response = await axios.request(requestOptions);
  return response.data;
};
// testing 
const getTestData = async () => {
  let body = JSON.stringify({
    method_name: "attendance_report_classwise",
    s_roll_no: 222870051,
  });
  let requestOptions = {
    method: "POST",
    data:body,
    url: "https://mis.mescray001.com/Tracker/api/v1/index.php",
  };
  const response = await axios.request(requestOptions);
  return response;
};
//common API's
const getCommonList = () => {
  return axios.get(API_URL + "common/list", headers);
};
const getClassList = () => {
  return axios.get(API_URL + "class/list", headers);
};
const getCenterList = () => {
  return axios.get(API_URL + "center/list", headers);
};
const getFileList = () => {
  return axios.get(API_URL + "common/customfolder", headers);
};
const uploadFile = async (body) => {
  const response = await axios.post(
    API_URL + `common/fileupload`,
    body,
    headers
  );
  return response.data;
};
//common API's
// Question
const getQuestionList = (body) => {
  return axios.get(
    API_URL +
      `questions/list?sub_id=${body.sub_id}&topic_id=${
        body.topic_id
      }&sub_topic_id=${body.sub_topic_id}&toughness_id=${
        body.toughness_id
      }&qtype_id=${body.qtype_id}&anstype_id=${body.anstype_id}&limit=${
        10 * body.limit
      }`,
    headers
  );
};
const getQuestionListOptions = (body) => {
  return axios.post(
    API_URL +
      `questions/qlist_wid_options_report`,body,
    headers
  );
};
const getSearchedQuestions = (body) => {
  return axios.get(
    API_URL +
      `questions/list/bysubject/search?search=${body.search}&subid=${body.subid}&limit=10&page=${body.page}`,
    headers
  );
};

const getQuesType = () => {
  return axios.get(API_URL + "quesType", headers);
};
const getAnsType = () => {
  return axios.get(API_URL + "ansType", headers);
};
const getOverviewData = async (qid) => {
  const response = await axios.post(
    API_URL + `questions/overview/${qid}`,
    {},
    headers
  );
  return response.data;
};
const getOptions = async (body) => {
  const response = await axios.post(API_URL + "option/List", body, headers);
  return response.data;
};
const getParagraphs = async (body) => {
  const response = await axios.post(
    API_URL + "questions/searchParagraph",
    body,
    headers
  );
  return response.data;
};
const createOverview = async (body) => {
  const response = await axios.put(API_URL + `questions/edit`, body, headers);
  return response.data;
};
const blockQuestion = async (body) => {
  const response = await axios.put(API_URL + `questions/Block`, body, headers);
  return response.data;
};
const createQuesText = async (body) => {
  const response = await axios.put(
    API_URL + `questions/SaveQText`,
    body,
    headers
  );
  return response.data;
};
const createHints = async (body) => {
  const response = await axios.post(
    API_URL + `questions/createHint`,
    body,
    headers
  );
  return response.data;
};
const getQuestionHistory = async (body) => {
  const response = await axios.post(
    API_URL + `questions/showQHistory`,
    body,
    headers
  );
  return response.data;
};
const saveExamDate = async (body) => {
  const response = await axios.post(
    API_URL + `questions/createExamName`,
    body,
    headers
  );
  return response.data;
};
const createOptions = async (body) => {
  const response = await axios.put(
    API_URL + `questions/updateOption`,
    body,
    headers
  );
  return response.data;
};
const createSolution = async (body) => {
  const response = await axios.post(
    API_URL + `questions/createSolution`,
    body,
    headers
  );
  return response.data;
};
const createQuesion = async (body) => {
  const response = await axios.post(
    API_URL + `questions/create`,
    body,
    headers
  );
  return response;
};
const TranslateQue = async (body) => {
  const response = await axios.post(
    API_URL + `questions/translateQus`,
    body,
    headers
  );
  return response;
};
const TranslateSolution = async (body) => {
  const response = await axios.post(
    API_URL + `questions/translateSolution`,
    body,
    headers
  );
  return response;
};
//Create Paper
const getReqpaperList = () => {
  return axios.get(API_URL + `paper/list`, headers);
};
const getCopyPaperList = (body) => {
  return axios.post(API_URL + `paper/paperListTocopyRequest`, body , headers);
};
const getDuplicatePaper = (pid) => {
  return axios.post(API_URL + `paper/CreateDuplicatepaperTocopyRequest`, {paper_id: pid}, headers);
};
const getReqpaperData = (pid) => {
  return axios.get(API_URL + `editpaper/${pid}`, headers);
};
const getPendingPaper = (page) => {
  return axios.get(API_URL + `paper/pending?limit=50&page=${page}`, headers);
};
const getPendingPaperList = (page) => {
  return axios.get(API_URL + `paper/pending/list?limit=50&page=${page}`, headers);
};
const getPendingPaperByUid = (uid, page) => {
  return axios.get(
    API_URL + `paper/pending/${uid}?limit=50&page=${page}`,
    headers
  );
};
const getCompletedPaper = (page) => {
  return axios.get(API_URL + `paper/complete?limit=50&page=${page}`, headers);
};
const getCompletedPaperList = (page) => {
  return axios.get(API_URL + `paper/complete/list?limit=50&page=${page}`, headers);
};
const getCompletedPaperByUid = (uid, page) => {
  return axios.get(
    API_URL + `paper/complete/${uid}?limit=50&page=${page}`,
    headers
  );
};
const getViewPaper = async (body) => {
  const response = await axios.post(API_URL + "paper/view", body, headers);
  return response.data;
};
const deletePaperReq = async (pid) => {
  const response = await axios.post(API_URL + `paper/delete`, {paper_id: pid}, headers);
  return response.data;
};


//DPP and exercise Upload
const getDppData = async (body) => {
  const response = await axios.post(API_URL + "mla_dpp/questions_list",body, headers);
  return response;
};
const getExcerciseData = async (body) => {
  const response = await axios.post(API_URL + "mla_exercise/questions_list",body, headers);
  return response;
};
const getVideoSolutionData = async (body) => {
  const response = await axios.post(API_URL + "mla_video_solution/questions_list",body, headers);
  return response;
};
const getVideoLinkData = async (body) => {
  const response = await axios.post(API_URL + "video_solution_link/questions_list",body, headers);
  return response;
};
const uploadExercise= async (body) => {
  const response = await axios.post(API_URL + "upload_exercise_dpp", body , headers);
  return response.data;
};
const ExamTypeList= async () => {
  const response = await axios.post(API_URL + "mla/exam_type_list",{} , headers);
  return response.data;
};
const TargetList= async () => {
  const response = await axios.post(API_URL + "mla/target_list",{} , headers);
  return response.data;
};
const SessionList= async () => {
  const response = await axios.post(API_URL + "mla/session_list",{} , headers);
  return response.data;
};
const uploadVideoSolution= async (body) => {
  const response = await axios.post(API_URL + "upload_video_solution", body , headers);
  return response;
};
const bulkUpdateHandler= async (body) => {
  const response = await axios.post(API_URL + "mla/update_dpp_questions", body , headers);
  return response;
};
const bulkDeleteHandler= async (body) => {
  const response = await axios.post(API_URL + "mla/bulk_exercise_dpp_questions_delete", body , headers);
  return response;
};




// Paper matrix
const getPaperMatrix = async (body) => {
  const response = await axios.post(API_URL + "paper/matrix", body, headers);
  return response.data;
};
const createPaperMatrix = async (body) => {
  const response = await axios.post(
    API_URL + "paper/matrix/create",
    body,
    headers
  );
  return response.data;
};
const getMatrixByUid = (pid, uid,sid) => {
  return axios.get(API_URL + `paper/matrix/${pid}?uid=${uid}&sid=${sid}`, headers);
};
const updatePaperMatrix = async (body) => {
  const response = await axios.put(
    API_URL + "paper/matrix/edit",
    body,
    headers
  );
  return response.data;
};
const getUsedQues = (body) => {
  return axios.get(
    API_URL +
      `paper/UsedQues/${body.pid}?topic_id=${body.topic_id}&sub_topic_id=${body.sub_topic_id}&toughness_id=${body.toughness_id}&type_id=${body.type_id}`,
    headers
  );
};
const getUnusedQues = (body) => {
  return axios.get(
    API_URL +
      `paper/UnusedQues/${body.pid}?topic_id=${body.topic_id}&sub_topic_id=${body.sub_topic_id}&toughness_id=${body.toughness_id}&type_id=${body.type_id}`,
    headers
  );
};
const getPreviousExamQid = (qid) => {
  return axios.get(API_URL + `paper/PreviousExamQid/${qid}`, headers);
};
const useNewQid = (body) => {
  return axios.get(
    API_URL +
      `paper/usenewqid/${body.paper_id}?matrixid=${body.matrix_id}&newqid=${body.newQID}&userid=${body.user_id}`,
    headers
  );
};
const getBlockedReason = () => {
  return axios.get(API_URL + "block/list", headers);
};
const qidBlockReason = async (body) => {
  const response = await axios.put(
    API_URL + `/paper/questionstatus`,
    body,
    headers
  );
  return response.data;
};
const getAvailableQues = (body) => {
  return axios.get(
    API_URL +
      `paper/ShowAvailableQuestion/${body.paper_id}?sub_id=${body.sub_id}&faculty_id=${body.faculty_id}&type_id=${body.type_id}&qno=${body.qno}&limit=${body.limit}`,
    headers
  );
};
const changeQuestion = (body) => {
  return axios.get(
    API_URL +
      `paper/ChangeQuestion/${body.paper_id}?sub_id=${body.sub_id}&faculty_id=${body.faculty_id}&type_id=${body.type_id}&qno=${body.qno}&qid=${body.qid}&pid=${body.pid}`,
    headers
  );
};
const changeQuestionTopicWise = (body) => {
  return axios.get(
    API_URL +
      `paper/loadQuestiontopicwise/${body.paper_id}?subid=${body.sub_id}&facultyid=${body.faculty_id}&type_id=${body.type_id}&qno=${body.qno}`,
    headers
  );
};
const updateQid = async (body) => {
  const response = await axios.put(
    API_URL + "paper/ChangeQuestion/updateQid",
    body,
    headers
  );
  return response.data;
};
const getRandomPaper = (body) => {
  return axios.get(
    API_URL +
      `paper/loadrandompaper/${body.paper_id}?subid=${body.sub_id}&facultyid=${body.faculty_id}&isboth=${body.isBoth}&center_id=${body.center_id}`,
    headers
  );
};
const submitPaper = async (body) => {
  const response = await axios.put(
    API_URL + "paper/SubmitPaper",
    body,
    headers
  );
  return response.data;
};
// Dummy paper
const getPaperName = async (body) => {
  const response = await axios.post(
    API_URL + "paper/Dummypaper/paperName",
    body,
    headers
  );
  return response.data;
};
const getQidData = async (body) => {
  const response = await axios.post(
    API_URL + "paper/Dummypaper/Qid",
    body,
    headers
  );
  return response.data;
};
const createDummy = async (body) => {
  const response = await axios.post(
    API_URL + "paper/Dummypaper/saveQid",
    body,
    headers
  );
  return response.data;
};
// Topic
const getTopicList = () => {
  return axios.get(API_URL + `topic/list`, headers);
};
const getSubTopicList = () => {
  return axios.get(API_URL + `topic/subtopic/list`, headers);
};
const getTopicListBySid = (sid) => {
  return axios.get(API_URL + `topic/${sid}`, headers);
};
const getSubTopicByTid = (tid) => {
  return axios.get(API_URL + `topic/subtopic/${tid}`, headers);
};
const getToughness = () => {
  return axios.get(API_URL + "toughness", headers);
};
//Paper Format
const getFormatList = async (body) => {
  const response = await axios.post(
    API_URL + "paper/format/List",
    body,
    headers
  );
  return response.data;
};
const createFormat = async (body) => {
  const response = await axios.post(
    API_URL + "paper/format/create",
    body,
    headers
  );
  return response.data;
};
const updateFormat = async (body) => {
  const response = await axios.put(API_URL + "paper/format/update", body, headers);
  return response.data;
};
const formatStatus = async (body) => {
  const response = await axios.put(API_URL + "paper/format/status", body, headers);
  return response.data;
};
const getFormatById = (formatId) => {
  return axios.get(API_URL + `paper/format/${formatId}`, headers);
};

//Publish Paper
const getPublishPaperList = (searchParam,date, page) => {
  return axios.get(
    API_URL + `paper/publish/list?search_paper=${searchParam}&search_exam=${date}&page=${page}&limit=10`,
    headers
  );
};
const getPendingPublishList = (uid, page) => {
  return axios.get(
    API_URL + `paper/publish/pending/list/${uid}?page=${page}&limit=10`,
    headers
  );
};
const getPublishPaperVeiw = (pid, uid) => {
  return axios.get(API_URL + `paper/publish/view/${pid}?uid=${uid}`, headers);
};

const UpdatePaperStatus= async(body)=>{
  const response = await axios.put(API_URL + "paper/UpdatePaperPrintStatus", body, headers);
  return response.data;
}
//request paper
const getPaperFormatByTrgt = async (tid) => {
  const response = await axios.post(
    API_URL + "paper/format/Listby/target",
    { tid: tid, active: 1 },
    headers
  );
  return response.data;
};
const getTotalQues = (fid) => {
  return axios.get(API_URL + `topic/total/quest/${fid}`, headers);
};
const createRequestPaper = async (body) => {
  const response = await axios.post(API_URL + "paper/create", body, headers);
  return response.data;
};
const updateRequestPaper = async (body) => {
  const response = await axios.put(API_URL + "paper/update", body, headers);
  return response.data;
};
//Edit Topic
const createTopic = async (body) => {
  const response = await axios.post(API_URL + "topic/create", body, headers);
  return response.data;
};
const updateTopic = async (body) => {
  const response = await axios.put(API_URL + `topic/update/${body.topic_id}`, body, headers);
  return response.data;
};
const updateTopicStatus = async (body) => {
  const response = await axios.put(
    API_URL + "topic/status/change",
    body,
    headers
  );
  return response.data;
};
//Edit SubTopic
const updateSubTopicStatus = async (body, stid) => {
  const response = await axios.put(
    API_URL + `subtopic/status/change/${stid}`,
    body,
    headers
  );
  return response.data;
};
const updateSubTopic = async (body, stid) => {
  const response = await axios.put(
    API_URL + `subtopic/update/${stid}`,
    body,
    headers
  );
  return response.data;
};
const createSubTopic = async (body, tid) => {
  const response = await axios.post(
    API_URL + `subtopic/create/${tid}`,
    body,
    headers
  );
  return response.data;
};
//User List
const getUserList = () => {
  return axios.get(API_URL + "user/list", headers);
};

const verifyOtp = (body) => {
  return axios.post(API_URL + "webverifyotp",body, headers);
};

// OTP List
const getOTPList = () => {
  return axios.get(API_URL + "user/OTPlist", headers);
};

const getTeamInfoList = () => {
  return axios.get(API_URL + "team/infolist", headers);
};
const getSubjectList = () => {
  return axios.get(API_URL + "subject/list", headers);
};
const getUserData = (id) => {
  return axios.get(API_URL + `user/${id}`, headers);
};
const createUser = async (body) => {
  const response = await axios.post(API_URL + "user/create", body, headers);
  return response.data;
};
const updateUser = async (body) => {
  const response = await axios.put(API_URL + `user/update`, body, headers);
  return response.data;
};

const homeworkModule=()=>{
  const response=axios.get("https://learning.motion.ac.in/motioneducation/api/v1/homeworkmodulelist", headers);
  return response;
}
const homeworkTopicList=(subid,batch,t_id,f_id,m_id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homeworktopiclist?module_id=${m_id}&subject_id=${subid}&faculty_id=${f_id}&batch=${batch}&topic_id=${t_id}`, headers);
  return response;

}

const homeworkDppExercise=(topic_id,f_id,batch,m_id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homework_exercise_dpp_list?topic_id=${topic_id}&faculty_id=${f_id}&module_id=1&batch=${batch}`, headers);
  return response;
}

const subTopicList=(id,m_id,f_id,sid,batch)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homeworksubtopiclist?topic_id=${id}&module_id=${2}&faculty_id=${f_id}&subject_id=${sid}&batch=${batch}`,headers);
  return response;
}

const reqQuestionList=(f_id,s_id,t_id,sub_id,batch,m_id,s_excer="Exercise-1",tough_id=1)=>{
  console.log(f_id,s_id,t_id,sub_id,batch,m_id,s_excer,tough_id);
 
   const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homework_questions_list?topic_id=${t_id}&faculty_id=${f_id}&subject_id=${s_id}&sub_topic_id=${sub_id}&excersie_type=${s_excer}&batch=${batch}&module_id=${m_id}&toughness_id=${tough_id}`,headers);
  
  return response;
}

const PreviewList=(m_id,fac_id,batch,sub_tid,sub_id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homework_preview_list?faculty_id=${fac_id}&subject_id=${sub_id}&batch=${batch}&sub_topic_id=${sub_tid}&module_id=&${m_id}`,headers);
  return response;
}

const PreviewQuestion=(id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homework_questions_review?id=${id}`,headers);
  return response;
}

const QuestionToughness=()=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/get_question_toughness`,headers);
  return response;
}

const getQuestionAttemptData = async (qidArray) => {
  const response = await axios.post(
    "https://learning.motion.ac.in/motioneducation/api/user/QuestionsAttemptData",
    { qid: qidArray },
    headers
  );
  return response.data;
};

const homeworkDetails=(schedule_id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/homework_details?faculty_schedule_id=${schedule_id}`,headers);
  return response;
}
const homeworkQuestionList=(schedule_id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/get_homework_list_data?faculty_schedule_id=${schedule_id}`,headers);
  return response;
}

const attemptedQuestion=(homework_id,user_id)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/get_homework_student_data_shoyeb?homework_id=${homework_id}&user_id=${user_id}`,headers);
  return response;
}
const attemptedQuestionOptions=(homework_id,user_id,qid)=>{
  const response=axios.get(`https://learning.motion.ac.in/motioneducation/api/v1/get_homework_list_questions_data?qid=${qid}&user_id=${user_id}&homework_id=${homework_id}`,headers);
  return response;
}
// Profile updates
const getProfileList = () => {
  return axios.get(API_URL + "profile/list", headers);
};
const getRightList = () => {
  return axios.get(API_URL + `rights/list`, headers);
};
const getRightsByPid = (pid) => {
  return axios.get(API_URL + `profile/rights/list/${pid}`, headers);
};
const createProfile = async (body) => {
  const response = await axios.post(API_URL + "user/profile", body, headers);
  return response.data;
};
const updateProfileStatus = async (body, id) => {
  const response = await axios.put(
    API_URL + `user/profile/status/${id}`,
    body,
    headers
  );
  return response.data;
};
const updateRightsByPid = async (body, pid) => {
  const response = await axios.post(
    API_URL + `user/profile/permission/${pid}`,
    body,
    headers
  );
  return response.data;
};


//Faculty Error Report


//Bulk Paper Upload

const bulkpaperUpload= async(formData) =>{
  const response = await axios.post(
    API_URL + `paper/createbulk_upload`,
    formData,
    headers
  );
  return response.data;
}

const bulkQuestionUpload= async(body) =>{
  console.log(body)
  const response = await axios.post(
    API_URL + `subject_wise_htmldata`,
    body,
    headers
  );
  return response.data;
}

const QuestionModuleUpload= async(body) =>{
  console.log(body)
  const response = await axios.post(
    API_URL + `question_module_htmldata`,
    body,
    headers
  );
  return response.data;
}

const SampleQuestionModuleUpload= async(body) =>{
  console.log(body)
  const response = await axios.post(
    API_URL + `sample_question_module_htmldata`,
    body,
    headers
  );
  return response.data;
}
const SampleQuestionSolutionUpload= async(body) =>{
  console.log(body)
  const response = await axios.post(
    API_URL + `question_module_with_solution_htmldata`,
    body,
    headers
  );
  return response.data;
}
const bulkQuestionTranslationUpload= async(body) =>{
  const response = await axios.post(
    API_URL + `bulk_question_translation`,
    body,
    headers
  );
  return response.data;
}
const bulkQuestionTranslationUploadUser= async(body) =>{
  const response = await axios.post(
    API_URL + `get_task_list_bulk_trans`,
    body,
    headers
  );
  return response.data;
}
const bulkSolutionTranslationUpload= async(body) =>{
  const response = await axios.post(
    API_URL + `bulk_solution_translation`,
    body,
    headers
  );
  return response.data;
}
const bulkQuestionTranslationData= async(body) =>{
  const response = await axios.post(
    API_URL + `download_task_details`,
    body,
    headers
  );
  return response.data;
}

// facultly Error report
const getPendingErrorReport = async (body) => {
  const response = await axios.post(API_URL+"faculty_error_report/pending_list", body, headers);
  return response.data;
};
const getCompletedErrorReports = async (body) => {
  const response = await axios.post(API_URL + "faculty_error_report/complete_list", body, headers);
  return response.data;
};
const FacultyErrorReportStatusChange = async (body) => {
  const response = await axios.post(API_URL + "faculty_error_report/updateStatusReview", body, headers);
  return response.data;
};

const FacultyErrorReportInfo = async (body) => {
  const response = await axios.post(API_URL + "faculty_error_report/qidreport_info", body, headers);
  return response.data;
};

const TopicWiseHtml= async(body) =>{
  
  const response = await axios.post(
    API_URL + `topic_wise_htmldata`,
    body,
    headers
  );
  return response.data;
}


// Publish papger generate pdf 
const getPaperInfo = (pid) => {
  return axios.get(API_URL + `Questionpaper/PaperInfo/${pid}`, headers);
};
const getAnswerKey = (pid,sub_sequence) => {
  return axios.get(API_URL + `Questionpaper/AnswerKey/${pid}?sub_sequence=${sub_sequence}`, headers);
};
const getQuestionMapping = (pid,sub_sequence) => {
  return axios.get(API_URL + `Questionpaper/FacultyQuesMapping/${pid}?sub_sequence=${sub_sequence}`, headers);
};
const getSolutons = (pid,sub_sequence) => {
  return axios.get(API_URL + `Questionpaper/SolInfo/${pid}?sub_sequence=${sub_sequence}`, headers);
};
const getPaperData = (pid,sub_sequence) => {
  return axios.get(API_URL + `Questionpaper/QuesInfo/${pid}?sub_sequence=${sub_sequence}`, headers);
};
const resetDisplayNo = async (body) => {
  const response = await axios.put(
    API_URL + `Questionpaper/Reset/Displayno`,
    body,
    headers
  );
  return response.data;
};
const regenerateDisplayNo = async (body) => {
  const response = await axios.post(
    API_URL + `Questionpaper/RegenerateDisplayno`,
    body,
    headers
  );
  return response.data;
};

const QuestionIngestionUpload = async (body) => {
  const response = await axios.post(API_URL + `combined_pdf_question_ingestion`, body, headers);
  return response.data;
}
const SeperateFileUpload = async (body) => {
  const response = await axios.post(API_URL + `/question_ingestion/saparate_pdf_question_upload`, body, headers);
  return response.data;
}

const getPdfImagesList = async (uploadId) => {
  const response = await axios.post(API_URL + `question_ingestion/pdf_images_list`,{upload_id: uploadId}, headers);
  return response.data;
}
const saveImageDetails = async (body) => {
  const response = await axios.post(API_URL + `question_ingestion/save_image_details`,body, headers);
  return response.data;
}
const prevUploadList = async () => {
  const response = await axios.post(
    API_URL + `question_ingestion/previous_uploads_list`,
    {},
    headers
  );
  return response.data;
};

const getQuestionsByUploadId = async (uploadId) => {
  const response = await axios.post(
    API_URL + `question_ingestion/questions_list`,
    { upload_id: uploadId },
    headers
  );
  return response.data;
};

const getViewQuestionDetails = async (body) => {
  const response = await axios.post(
    API_URL + `question_ingestion/pdf_question_review`,
    body,
    headers
  );
  return response.data;
};

const saveAllImagesDetails = async (body) => {
  const response = await axios.post(
    API_URL + `/question_ingestion/submit_task_images_annotation`,
    body,
    headers
  );
  return response.data;
};

const saveQuestionData = async (body) => {
  const response = await axios.post(
    API_URL + `question_ingestion/edit_auto_generated_qus`,
    body,
    headers
  );
  return response.data;
};
const editQuestionOptions = async (body) => {
  const response = await axios.post(
    API_URL + `question_ingestion/edit_auto_generated_options`,
    body,
    headers
  );
  return response.data;
};

const editQuestionSolution = async (body) => {
  const response = await axios.post(
    API_URL + `question_ingestion/edit_auto_generated_solution`,
    body,
    headers  
  );
  return response.data;
};
const getFinalSavedQuestionList = async (uploadId) => {
  const response = await axios.post(
    API_URL + `question_ingestion/final_saved_question_list`,
    { upload_id: uploadId },
    headers
  );
  return response.data;
};
const KeepQuestion = async (body) => {
  const response = await axios.post(
    API_URL + `question_ingestion/new_qus_keep_discard`,
    body,
    headers
  );
  return response.data;
};
const DownloadQuestionIngestion = async (body) => {
  const response = await axios.post(
    API_URL + `question_ingestion/download_final_questions_details`,
    body,
    headers
  );
  return response.data;
};

const GetClassBatchList = async () => {
  const response = await axios.post(
    API_URL + `school_batch_list`,
    {},
    headers  
  );
  return response.data;
};

const submitAttendance = async (body) => {
  const response = await axios.post(
    API_URL + `save_school_class_attendance`,
    body,
    headers
  );
  return response.data;
};

const batchWiseStudentList = async (body) => {
  const response = await axios.post(
    API_URL + `batchwise_students_list`,
    body,
    headers  
  );
  return response.data;
};


const userService = {
  getBatchData,
  getDateList,
  getScheduleList,
  getReports,
  addCourseReport,
  getAttendanceData,
  getTestData,
  getCommonList,
  getFileList,
  uploadFile,
  getClassList,
  getReqpaperList,
  getCopyPaperList,
  getDuplicatePaper,
  getReqpaperData,
  getPendingPaper,
  getPendingPaperList,
  getPendingPaperByUid,
  getCompletedPaperByUid,
  getCompletedPaper,
  getCompletedPaperList,
  getPaperMatrix,
  getMatrixByUid,
  getRandomPaper,
  updatePaperMatrix,
  updateQid,
  getAnsType,
  getQuesType,
  submitPaper,
  getPaperName,
  getQidData,
  createDummy,
  getUsedQues,
  getUnusedQues,
  getPreviousExamQid,
  getQuestionListOptions,
  useNewQid,
  getBlockedReason,
  qidBlockReason,
  getAvailableQues,
  changeQuestion,
  changeQuestionTopicWise,
  createPaperMatrix,
  getViewPaper,
  deletePaperReq,
  getTopicList,
  getSubTopicList,
  getTopicListBySid,
  getSubTopicByTid,
  getToughness,
  getPublishPaperList,
  getPendingPublishList,
  getPublishPaperVeiw,
  getPaperFormatByTrgt,
  getTotalQues,
  createRequestPaper,
  updateRequestPaper,
  createTopic,
  updateTopic,
  updateTopicStatus,
  updateSubTopicStatus,
  updateSubTopic,
  createSubTopic,
  getUserList,
  getFormatList,
  createFormat,
  updateFormat,
  formatStatus,
  getFormatById,
  getTeamInfoList,
  getCenterList,
  getQuestionList,
  getSearchedQuestions,
  getOverviewData,
  getOptions,
  getParagraphs,
  createOverview,
  blockQuestion,
  createQuesText,
  createHints,
  getQuestionHistory,
  saveExamDate,
  createOptions,
  createSolution,
  createQuesion,
  getSubjectList,
  getUserData,
  createUser,
  updateUser,
  getProfileList,
  getRightList,
  getRightsByPid,
  createProfile,
  updateProfileStatus,
  updateRightsByPid,
  getPaperInfo,
  getQuestionMapping,
  getSolutons,
  getAnswerKey,
  getPaperData,
  resetDisplayNo,
  regenerateDisplayNo,
  homeworkModule,
  homeworkTopicList,
  homeworkDppExercise,
  subTopicList,
  reqQuestionList,
  PreviewList,
  PreviewQuestion,
  QuestionToughness,
  getQuestionAttemptData,
  homeworkDetails,
  homeworkQuestionList,
  attemptedQuestion,
  attemptedQuestionOptions,
  UpdatePaperStatus,
  bulkpaperUpload,
  bulkQuestionUpload,
  TopicWiseHtml,
  QuestionModuleUpload,
  SampleQuestionModuleUpload,
  SampleQuestionSolutionUpload,
  bulkQuestionTranslationUpload,
  bulkQuestionTranslationUploadUser,
  bulkSolutionTranslationUpload,
  bulkQuestionTranslationData,
  TranslateQue,
  TranslateSolution,
  getDppData,
  getExcerciseData,
  getVideoSolutionData,
  uploadExercise,
  ExamTypeList,
  TargetList,
  SessionList,
  uploadVideoSolution,
  bulkUpdateHandler,
  bulkDeleteHandler,
  getVideoLinkData,
  getPendingErrorReport,
  getCompletedErrorReports,
  verifyOtp,
  getOTPList,
  FacultyErrorReportStatusChange,
  FacultyErrorReportInfo,
  QuestionIngestionUpload,
  getPdfImagesList,
  saveImageDetails,
  getFinalSavedQuestionList,
  prevUploadList,
  getQuestionsByUploadId,
  getViewQuestionDetails,
  saveAllImagesDetails,
  saveQuestionData,
  SeperateFileUpload,
  KeepQuestion,
  editQuestionSolution,
  editQuestionOptions,
  DownloadQuestionIngestion,
  GetClassBatchList,
  submitAttendance,
  batchWiseStudentList,
};

export default userService;

//You can see that we add a HTTP header with the help of authHeader() function when requesting authorized resource.
